// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Drawer_overlay__SojAo","overlayVisible":"Drawer_overlayVisible__1VGkg","drawer":"Drawer_drawer__1z6V1","items":"Drawer_items__18U4m"};